import BaseComponent from "../BaseComponent";
import ToggleInput from "components/Properties/InputComponents/ToggleInput";
import DropDownInput from "components/Properties/InputComponents/DropDownInput";
import {NumberSliderInput} from "components/Properties/InputComponents/NumberInput";

const PhysicsComponent = ({
  isObjectScripting,
  selectedObject,
  inputOnChange,
  checkboxOnChange,
  dropdownOnChange,
  dropdownOpened,
  setDropdownOpened,
}) => {
  const isMeshObject = selectedObject.type === "Mesh" && selectedObject.userData.type === "mesh";
  const hasBody = selectedObject.userData.hasBody || false;
  const bodyType = selectedObject.userData.bodyType || "Default";
  const isKinematic = selectedObject.userData.isKinematic || false;

  if (isObjectScripting && (selectedObject.type === "Group" || isMeshObject)) {
    return (
      <BaseComponent title="Physics" foldable={true}>
        {<ToggleInput name="Body" checked={hasBody} checkboxOnChange={checkboxOnChange} />}
        {hasBody && (
          <>
            <ToggleInput name="Anchored" checked={isKinematic} checkboxOnChange={checkboxOnChange} depth={1} />
            <DropDownInput
              name="BodyType"
              array={["Default", "Box", "Sphere", "Hull", "Convex", "Concave"]}
              dropdownOnChange={dropdownOnChange}
              value={bodyType.charAt(0).toUpperCase() + bodyType.slice(1)}
              selectedObject={selectedObject}
              dropdownOpened={dropdownOpened}
              setDropdownOpened={setDropdownOpened}
              depth={1}
            />
            <NumberSliderInput
              name="Mass"
              value={selectedObject.userData.mass}
              min={0}
              max={100}
              step={1}
              inputOnChange={inputOnChange}
              depth={1}
            />
            <NumberSliderInput
              name="Friction"
              value={selectedObject.userData.friction}
              min={0}
              max={1}
              step={0.1}
              inputOnChange={inputOnChange}
              depth={1}
            />
          </>
        )}
      </BaseComponent>
    );
  } else {
    return null;
  }
};

export default PhysicsComponent;
